import React, { useState, useEffect } from 'react';
import { 
    Package, Truck, Box, Printer, ArrowRight, User, FileSpreadsheet 
} from 'lucide-react';
import api from '../../api/axios';
import { echo } from '../../utils/echo';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

const MAX_VEHICLE_CAPACITY_KG = 1500; 

const ShipmentsPage = () => {
    const [unassigned, setUnassigned] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [filters, setFilters] = useState({ origin: '', destination: '' });
    const [branches, setBranches] = useState([]);
    const [selectedDriverId, setSelectedDriverId] = useState('');
    const [expandedShipments, setExpandedShipments] = useState([]); 
   const now = new Date();
const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(now.getDate() - 7);

const enviosRecientes = unassigned.filter(s => new Date(s.created_at) >= sevenDaysAgo);
const enviosAtrasados = unassigned.filter(s => new Date(s.created_at) < sevenDaysAgo);
    const fetchData = async () => {
        try {
            const [shipRes, driverRes, branchRes] = await Promise.all([
                api.get('/shipments'),
                api.get('/drivers'),
                api.get('/branches')
            ]);
            
            const rawShipments = shipRes.data.data || shipRes.data;
            const rawDrivers = driverRes.data.data || driverRes.data;

            // Filtramos los que no tienen chofer para la tabla de arriba
            setUnassigned(rawShipments.filter(s => !s.driver_id));
            setDrivers(rawDrivers);
            setBranches(branchRes.data);
        } catch (error) {
            console.error("Error al cargar datos operativos:", error);
        }
    };

    useEffect(() => {
        fetchData();

        const channel = echo.channel('shipments');
        const handleStatusChange = (e) => {
            console.log("⚡ [Pusher] Actualización de envío en vivo recibida:", e);
            fetchData();
        };

        channel.listen('.status.changed', handleStatusChange);
        channel.listen('status.changed', handleStatusChange);
        channel.listen('ShipmentStatusChanged', handleStatusChange);

        return () => {
            channel.stopListening('.status.changed');
            channel.stopListening('status.changed');
            channel.stopListening('ShipmentStatusChanged');
        };
    }, []);

    const toggleSelection = (shipment) => {
    // 🛑 CANDADO EN FRONTEND: Validamos que el pago exista y sea 'approved'
    // Usamos (!shipment.payment) para evitar errores si la relación es null
    if (!shipment.payment || shipment.payment.status !== 'approved') {
        return; 
    }

    setSelectedIds(prev => 
        prev.includes(shipment.id) ? prev.filter(i => i !== shipment.id) : [...prev, shipment.id]
    );
};
    const isDriverBusy = (driver) => {
        return driver.shipments?.some(s => 
            s.current_status?.toLowerCase().includes('tránsito') || 
            s.current_status?.toLowerCase().includes('transito')
        );
    };

    const handleUpdateStatus = async (shipmentId, newStatus) => {
        try {
            await api.put(`/shipments/${shipmentId}/status`, { status: newStatus });
            await fetchData(); 
            console.log(`✅ Guía ${shipmentId} actualizada.`);
        } catch (error) {
            console.error("Error al actualizar:", error);
            alert("❌ No se pudo actualizar el estado.");
        }
    };

    const handlePrintGuide = (trackingNumber) => {
    // 1. Usa import.meta.env en lugar de process.env
    // 2. Asegúrate de que la variable en tu .env o en Netlify se llame VITE_API_URL
    const baseUrl = import.meta.env.VITE_BACKEND_URL;

    // Validación de seguridad para no abrir ventanas vacías
    if (!baseUrl) {
        console.error("La variable VITE_API_URL no está definida.");
        alert("Error de configuración: La URL de la API no está cargada.");
        return;
    }

    const url = `${baseUrl}/api/shipments/${trackingNumber}/label`;
    const pdfWindow = window.open(url, '_blank');
    
    if (!pdfWindow) {
        alert("⚠️ Por favor, habilita las ventanas emergentes.");
    }
};

    const handleConfirmAssignment = async () => {
        if (!selectedDriverId) return alert("⚠️ Selecciona un chofer.");
        try {
            await api.post('/shipments/bulk-status', { 
                ids: selectedIds, 
                driver_id: selectedDriverId,
                status: 'En Tránsito' 
            });
            alert(`✅ DESPACHO EXITOSO.`);
            setSelectedIds([]);
            setSelectedDriverId('');
            fetchData();
        } catch (error) {
            alert("❌ Error al despachar: " + (error.response?.data?.error || "Revisa la consola"));
        }
    };

    const toggleBultos = (shipmentId) => {
        setExpandedShipments(prev => prev.includes(shipmentId) ? prev.filter(id => id !== shipmentId) : [...prev, shipmentId]);
    };

    const filteredPending = unassigned.filter(s => 
        (filters.origin === '' || s.origin_branch_id == filters.origin) &&
        (filters.destination === '' || s.destination_branch_id == filters.destination)
    );
    
    const filteredHistory = drivers.flatMap(d => d.shipments || [])
    .filter(s => ['entregado', 'arribado'].includes(s.current_status?.toLowerCase()))
    .filter(s => 
        (filters.origin === '' || String(s.origin_branch_id) === String(filters.origin)) &&
        (filters.destination === '' || String(s.destination_branch_id) === String(filters.destination))
    )
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
    const totalSelectedWeight = unassigned
        .filter(s => selectedIds.includes(s.id))
        .reduce((acc, s) => acc + Number(s.weight), 0);

    // 1. Obtenemos todos los envíos de todos los choferes en un solo arreglo plano
    const todosLosEnviosAsignados = drivers.flatMap(driver => 
        (driver.shipments || []).map(s => ({ ...s, driver_name: driver.name }))
    );

    // 2. Filtramos: Solo lo que NO está entregado (Esto limpia la lista de la unidad)
    const enviosActivos = todosLosEnviosAsignados.filter(s => s.current_status !== 'entregado');

    // 3. Historial: Solo lo que ya se marcó como 'entregado'
    const historialEntregados = todosLosEnviosAsignados.filter(s => s.current_status === 'entregado');

    const handleExportShipments = async () => {
        try {
            // Podrías agregar un estado "isExporting" para deshabilitar el botón
            const response = await api.get('/export/shipments', {
                responseType: 'blob' 
            });

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Envios_GrupoTBT.csv');
            document.body.appendChild(link);
            link.click();
            
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al exportar:", error);
            alert("❌ No se pudo generar el reporte de envíos.");
        }
    };
    const handleMarkAllArrived = async (driver) => {
    const activeShipments = driver.shipments?.filter(s => s.current_status !== 'Arribado' && s.current_status !== 'Entregado') || [];
    
    if (activeShipments.length === 0) return;

    try {
        // En lugar de múltiples PUT, hacemos UN solo POST al endpoint de bulk
        await api.post('/shipments/bulk-status', { 
            ids: activeShipments.map(s => s.id),
            status: 'Arribado' 
        });
        
        await fetchData();
        alert("✅ Despacho masivo exitoso.");
    } catch (error) {
        alert("❌ Error al procesar masivamente: " + (error.response?.data?.error || "Error de servidor"));
    }
};
useEffect(() => {
    // 1. Cargamos datos al inicio
    fetchData();

    // 2. Polling: Preguntar al servidor cada 10 segundos si hay algo nuevo.
    // Es lo suficientemente rápido para que parezca "tiempo real"
    // y no consume recursos excesivos.
    const interval = setInterval(() => {
        fetchData();
        console.log("🔄 Sincronizando datos con el servidor...");
    }, 10000); // 10,000 ms = 10 segundos

    // 3. Limpieza al cerrar el componente
    return () => clearInterval(interval);
}, []); // Array vacío para que solo se ejecute una vez al cargar

const handleDeleteShipment = async (shipmentId) => {
    if (!window.confirm("¿Estás seguro de eliminar este envío atrasado? Esta acción es irreversible.")) return;
    
    try {
        await api.delete(`/shipments/${shipmentId}`);
        await fetchData(); // Recargar datos
        alert("✅ Envío eliminado correctamente.");
    } catch (error) {
        alert("❌ No se pudo eliminar el envío.");
    }
};
    return (
        
        <div className="space-y-10 pb-40 animate-in fade-in duration-500">
            
            <section className="space-y-10">
    {/* TABLA 1: ENVÍOS RECIENTES */}
    <div className="space-y-4">
        <div className="flex justify-between items-end">
            <div>
                <h3 className="text-3xl font-black uppercase tracking-tighter text-[#CE010B]">
                    Gestión <span className="text-black dark:text-white">Operativa</span>
                </h3>
                <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest italic">
                    Pendientes por despachar (Recientes)
                </p>
            </div>
        </div>
        <div className="bg-white dark:bg-black/40 rounded-[2.5rem] border border-black/5 shadow-xl max-h-[400px] overflow-y-auto custom-scrollbar">
            <table className="w-full text-left border-collapse">
                <thead className="bg-gray-50 dark:bg-white/5 border-b border-black/5">
                    <tr className="text-[9px] uppercase text-gray-400 font-black border-b border-black/5">
                        <th className="py-3 px-4 text-center">Sel.</th>
                        <th className="py-3 px-4">Guía</th>
                        <th className="py-3 px-4">Ruta</th>
                        <th className="py-3 px-4 text-center">Peso</th>
                        <th className="py-3 px-4">Estado</th>
                        <th className="py-3 px-4 text-right italic">Acción</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-black/5 dark:divide-white/5">
                    {enviosRecientes.map(s => {
                        const origin = branches.find(b => String(b.id) === String(s.origin_branch_id));
                        const destination = branches.find(b => String(b.id) === String(s.destination_branch_id));
                        return (
                            <tr key={s.id} onClick={() => toggleSelection(s)} className={`transition-all cursor-pointer ${selectedIds.includes(s.id) ? 'bg-[#CE010B]/5' : 'hover:bg-gray-50 dark:hover:bg-white/5'}`}>
                                <td className="py-2 px-4 text-center">
                                    <input type="checkbox" checked={selectedIds.includes(s.id)} disabled={s.payment?.status !== 'approved'} onChange={() => {}} className="w-4 h-4 accent-[#CE010B] cursor-pointer" />
                                </td>
                                <td className="py-2 px-4 font-black text-[11px] text-[#CE010B]">#{s.tracking_number}</td>
                                <td className="py-2 px-4 text-[9px] font-bold uppercase">{origin?.name || '---'} <ArrowRight size={9} className="inline mx-1 text-[#CE010B]"/> {destination?.name || '---'}</td>
                                <td className="py-2 px-4 text-center font-black text-[11px]">{s.weight} kg</td>
                                <td className="py-2 px-4">{s.payment?.status === 'approved' ? (<span className="text-[8px] font-black uppercase py-1 px-2 rounded-lg bg-emerald-500/10 text-emerald-600 ring-1 ring-emerald-500/20">🟢 Pagado</span>) : (<span className="text-[9px] font-black uppercase px-2 py-1 bg-gray-100 dark:bg-white/10 rounded-lg text-gray-500">Pendiente</span>)}</td>
                                <td className="py-2 px-4 text-right"><button onClick={(e) => { e.stopPropagation(); handlePrintGuide(s.tracking_number); }} className="p-1.5 text-gray-400 hover:text-[#CE010B]"><Printer size={16} /></button></td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    </div>

    {/* TABLA 2: ENVÍOS ATRASADOS */}
    {enviosAtrasados.length > 0 && (
    <section className="space-y-4 animate-in fade-in duration-500">
        {/* Mismo estilo de título y espaciado */}
        <div className="flex justify-between items-end">
            <div>
                <h3 className="text-2xl font-black uppercase tracking-tighter">
                    Envíos <span className="text-[#CE010B]">Atrasados</span> ({enviosAtrasados.length})
                </h3>
            </div>
        </div>
        
        {/* Contenedor idéntico a la tabla principal */}
        <div className="bg-white dark:bg-black/40 rounded-[2.5rem] border border-black/5 shadow-xl max-h-[400px] overflow-y-auto custom-scrollbar">
            <table className="w-full text-left border-collapse">
                {/* Header idéntico (mismo bg, mismo padding, mismo texto) */}
                <thead className="bg-gray-50 dark:bg-white/5 border-b border-black/5">
                    <tr className="text-[9px] uppercase text-gray-400 font-black border-b border-black/5">
                        <th className="py-3 px-4">Guía</th>
                        <th className="py-3 px-4">Fecha Creación</th>
                        <th className="py-3 px-4 text-right italic">Acción</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-black/5 dark:divide-white/5">
                    {enviosAtrasados.map(s => (
                        <tr key={s.id} className="hover:bg-gray-50 dark:hover:bg-white/5 transition-all">
                            <td className="py-2 px-4 font-black text-[11px] text-[#CE010B]">#{s.tracking_number}</td>
                            <td className="py-2 px-4 text-[10px] font-bold text-gray-500 uppercase">
                                {new Date(s.created_at).toLocaleDateString()}
                            </td>
                            <td className="py-2 px-4 text-right">
                                <button 
                                    onClick={() => handleDeleteShipment(s.id)}
                                    className="p-1.5 text-gray-400 hover:text-red-600 transition-colors"
                                >
                                    <span className="text-[9px] font-black uppercase">Eliminar</span>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </section>
)}
</section>


            {/* SECCIÓN 2: MONITOR DE FLOTA */}
            <section className="space-y-4">
                <h3 className="text-2xl font-black uppercase tracking-tighter">Monitor de <span className="text-[#CE010B]">Flota</span></h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {drivers.map(driver => {
                        // Filtramos envíos activos (no Entregado y no Arribado)
                        const activeShipments = driver.shipments?.filter(s => s.current_status !== 'Arribado' && s.current_status !== 'Entregado') || [];
                        
                        // Calculamos carga solo de lo activo
                        const currentLoad = activeShipments.reduce((acc, s) => acc + Number(s.weight), 0);
                        const capacityPercentage = Math.min((currentLoad / MAX_VEHICLE_CAPACITY_KG) * 100, 100);

                        return (
                            <div key={driver.id} className="bg-white dark:bg-black/40 rounded-[2.5rem] border border-black/5 p-8 shadow-sm">
                                <div className="flex justify-between items-start mb-6">
                                    <div className="flex items-center gap-4">
                                        <div className="w-14 h-14 rounded-2xl bg-[#CE010B] flex items-center justify-center text-white shadow-lg shadow-[#CE010B]/20">
                                            <Truck size={28} />
                                        </div>
                                        <div>
                                            <h4 className="font-black uppercase text-sm leading-tight">{driver.name}</h4>
                                            <p className="text-[10px] font-bold text-gray-400 uppercase">{driver.vehicle_plate}</p>
                                        </div>
                                    </div>
                                    
                                    {/* BOTÓN Y CONTADOR */}
                                    <div className="flex gap-2 items-center">
                                        {activeShipments.length > 0 && (
                                            <button 
                                                onClick={() => handleMarkAllArrived(driver)}
                                                className="px-3 py-1.5 rounded-full bg-[#CE010B] text-white text-[9px] font-black uppercase hover:bg-red-800 transition-all active:scale-95 shadow-sm"
                                            >
                                                Arribar Todo
                                            </button>
                                        )}
                                        <div className="bg-gray-100 dark:bg-white/5 px-4 py-1.5 rounded-full">
                                            <span className="text-[10px] font-black uppercase">{activeShipments.length} Guías</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="space-y-2 mb-6">
                                    <div className="flex justify-between text-[9px] font-black uppercase text-gray-400">
                                        <span>Carga: {currentLoad}kg</span>
                                        <span>Máx: {MAX_VEHICLE_CAPACITY_KG}kg</span>
                                    </div>
                                    <div className="h-2 w-full bg-gray-100 dark:bg-white/5 rounded-full overflow-hidden">
                                        <div className={`h-full rounded-full transition-all duration-1000 ${capacityPercentage > 85 ? 'bg-orange-500' : 'bg-[#CE010B]'}`} 
                                            style={{ width: `${capacityPercentage}%` }} />
                                    </div>
                                </div>

                                <div className="space-y-3 max-h-72 overflow-y-auto pr-2 custom-scrollbar">
                                    {activeShipments.map(ship => (
                                        <div key={ship.id} className="p-4 bg-gray-50 dark:bg-white/5 rounded-2xl border border-black/5">
                                            <div className="flex justify-between items-center mb-2">
                                                <div>
                                                    <p className="font-black text-[#CE010B] text-[10px]">#{ship.tracking_number}</p>
                                                    <p className="text-[9px] font-bold uppercase opacity-50">{ship.destination_branch?.name || 'En ruta'}</p>
                                                </div>
                                                
                                                <select 
                                                    value={ship.current_status || 'En Tránsito'} 
                                                    onChange={(e) => handleUpdateStatus(ship.id, e.target.value)}
                                                    className="text-[8px] font-black uppercase py-1 px-2 rounded-md border-none ring-1 ring-black/5 bg-white dark:bg-black/40 cursor-pointer focus:ring-1 focus:ring-[#CE010B]"
                                                >
                                                    <option value="En Tránsito">En Tránsito</option>
                                                    <option value="Arribado">Arribado</option>
                                                </select>
                                            </div>
                                            <div className="flex gap-3 pt-1">
                                                <button onClick={() => toggleBultos(ship.id)} className="flex items-center gap-1 text-[8px] font-black uppercase text-gray-400 hover:text-[#CE010B]">
                                                    <Box size={10}/> {expandedShipments.includes(ship.id) ? 'Ocultar' : 'Bultos'}
                                                </button>
                                                <button onClick={() => handlePrintGuide(ship.tracking_number)} className="flex items-center gap-1 text-[8px] font-black uppercase text-gray-400 hover:text-blue-500">
                                                    <Printer size={10}/> Guía
                                                </button>
                                            </div>
                                            
                                            {expandedShipments.includes(ship.id) && (
                                                <ul className="mt-2 pt-2 border-t border-black/5 space-y-1 animate-in slide-in-from-top-2">
                                                    {ship.packages?.map(pkg => (
                                                        <li key={pkg.id} className="text-[9px] font-bold text-gray-500 flex justify-between uppercase italic">
                                                            <span>• {pkg.description}</span>
                                                            <span>{pkg.weight}kg</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
            {/* PASO 3: NUEVA SECCIÓN DE HISTORIAL DE ENTREGAS */}
            <section className="mt-12 space-y-6">
    <div className="flex justify-between items-end">
        <h3 className="text-2xl font-black uppercase tracking-tighter">
            Historial de <span className="text-[#CE010B]">Entregas Finalizadas</span>
        </h3>
        <div className="flex gap-2">
            <select className="p-2 rounded-xl bg-gray-50 dark:bg-black/20 text-[10px] font-black border-none ring-1 ring-black/5 cursor-pointer"
                onChange={e => setFilters({...filters, origin: e.target.value})}>
                <option value="">Origen</option>
                {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
            <select className="p-2 rounded-xl bg-gray-50 dark:bg-black/20 text-[10px] font-black border-none ring-1 ring-black/5 cursor-pointer"
                onChange={e => setFilters({...filters, destination: e.target.value})}>
                <option value="">Destino</option>
                {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
        </div>
    </div>
    <div className="rounded-[2.5rem] border border-black/5 bg-white dark:bg-black/40 shadow-sm max-h-[400px] overflow-y-auto custom-scrollbar">
        <table className="w-full text-left text-[10px] border-collapse">
            <thead className="bg-gray-50 dark:bg-white/5 border-b border-black/5">
                <tr className="uppercase font-black text-gray-400">
                    <th className="p-5">Guía</th><th className="p-5">Chofer</th><th className="p-5">Origen</th><th className="p-5">Destino</th><th className="p-5">Estado</th><th className="p-5 text-right">Fecha Entrega</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-black/5 dark:divide-white/5">
                {filteredHistory.map(ship => {
                    const responsable = drivers.find(d => d.id === ship.driver_id);
                    const origin = branches.find(b => String(b.id) === String(ship.origin_branch_id));
                    const destination = branches.find(b => String(b.id) === String(ship.destination_branch_id));
                    const isDelivered = ship.current_status?.toLowerCase() === 'entregado';
                    
                    return (
                        <tr key={ship.id} className="hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                            <td className="p-5 font-black text-[#CE010B]">#{ship.tracking_number}</td><td className="p-5 font-bold uppercase">{responsable?.name || 'Desconocido'}</td><td className="p-5 font-bold uppercase">{origin?.name || '---'}</td><td className="p-5 font-bold uppercase">{destination?.name || '---'}</td>
                            <td className="p-5">
                                <select 
                                    value={ship.current_status} 
                                    onChange={(e) => handleUpdateStatus(ship.id, e.target.value)}
                                    disabled={isDelivered}
                                    className={`text-[9px] font-black uppercase p-2 rounded-lg cursor-pointer ${isDelivered ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-gray-100 text-black dark:bg-black/20 dark:text-white'}`}
                                >
                                    <option value="Arribado">Arribado</option>
                                    <option value="En Tránsito">En Tránsito</option>
                                    <option value="Entregado">Entregado</option>
                                </select>
                            </td>
                            <td className="p-5 text-right font-mono font-bold opacity-60">{new Date(ship.updated_at).toLocaleString('es-MX')}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
</section>
            {/* BARRA DE DESPACHO FLOTANTE */}
            {selectedIds.length > 0 && (
                <div className="fixed bottom-10 left-1/2 -translate-x-1/2 bg-white dark:bg-zinc-900 p-6 rounded-[2.5rem] shadow-2xl border-2 border-[#CE010B]/20 flex items-center gap-8 z-50 animate-in slide-in-from-bottom-10 duration-300">
                    <div className="flex items-center gap-4 border-r border-gray-100 dark:border-white/10 pr-8">
                        <div className="w-12 h-12 rounded-2xl bg-[#CE010B]/10 flex items-center justify-center text-[#CE010B]">
                            <Package size={24} />
                        </div>
                        <div>
                            <p className="text-[10px] font-black uppercase text-gray-400">Seleccionados</p>
                            <p className="text-xl font-black">{selectedIds.length} <span className="text-xs text-gray-500">Paquetes</span></p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 border-r border-gray-100 dark:border-white/10 pr-8">
                        <div>
                            <p className="text-[10px] font-black uppercase text-gray-400">Peso Total</p>
                            <p className="text-xl font-black">{totalSelectedWeight.toFixed(2)} <span className="text-xs text-gray-500">KG</span></p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <select 
                            value={selectedDriverId}
                            onChange={(e) => setSelectedDriverId(e.target.value)}
                            className="bg-gray-100 dark:bg-white/5 border-none rounded-2xl px-6 py-3 text-xs font-black uppercase ring-1 ring-black/5 focus:ring-[#CE010B] transition-all cursor-pointer"
                        >
                            <option value="">Seleccionar Chofer</option>
                            {drivers.map(d => (
                                <option 
                                    key={d.id} 
                                    value={d.id} 
                                    disabled={isDriverBusy(d)}
                                    className={isDriverBusy(d) ? 'text-gray-400' : ''}
                                >
                                    {d.name} ({d.vehicle_plate}) {isDriverBusy(d) ? ' 🔴 EN RUTA' : ' 🟢 DISPONIBLE'}
                                </option>
                            ))}
                        </select>

                        <button 
                            onClick={handleConfirmAssignment}
                            disabled={!selectedDriverId}
                            className={`px-8 py-3 rounded-2xl font-black uppercase text-xs tracking-widest transition-all ${
                                selectedDriverId 
                                ? 'bg-[#CE010B] text-white shadow-lg shadow-[#CE010B]/30 hover:scale-105 active:scale-95' 
                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            }`}
                        >
                            Confirmar Despacho
                        </button>

                        <button 
                            onClick={() => setSelectedIds([])}
                            className="text-[10px] font-black uppercase text-gray-400 hover:text-black dark:hover:text-white underline underline-offset-4"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShipmentsPage;